var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bec3ce;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,5.206A6.794,6.794,0,1,0,18.794,12,6.794,6.794,0,0,0,12,5.206Zm3,8.5H12a1,1,0,0,1-1-1V8.114a1,1,0,1,1,2,0V11.7h2a1,1,0,0,1,0,2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,1.871A10.129,10.129,0,1,0,22.129,12,10.141,10.141,0,0,0,12,1.871Zm0,18.258A8.129,8.129,0,1,1,20.129,12,8.138,8.138,0,0,1,12,20.129Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallClock);
export default __webpack_public_path__ + "static/media/wall-clock.34ae6bee.svg";
export { ForwardRef as ReactComponent };